import { gql } from '@apollo/client'

export const CREATE_BRAND = gql`
  mutation createBrand($input: CreateBrandInput!) {
    data: createBrand(input: $input) {
      id
    }
  }
`
